/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Book_Button_OffInputs */

const fr_label_book_button_off = /** @type {(inputs: Label_Book_Button_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masqué`)
};

const en_label_book_button_off = /** @type {(inputs: Label_Book_Button_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hidden`)
};

/**
* | output |
* | --- |
* | "Hidden" |
*
* @param {Label_Book_Button_OffInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const label_book_button_off = /** @type {((inputs?: Label_Book_Button_OffInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Book_Button_OffInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_label_book_button_off(inputs)
	return en_label_book_button_off(inputs)
});